var productCardMarkup = 
    `<span id="{{lid}}">
	</span>
	<div class="swym-wishlist-grid">
		{{#products}} 
	<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-lid="{{lid}}" data-product-url="{{du}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
		<div class="swym-title swym-title-1">
			{{dt}}
		</div></button>
		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{cu}}{{pr}}
			</div>
        </div>
		<button id="{{#atcType}}swym-custom-view-more{{/atcType}}{{^atcType}}swym-custom-add-toCartBtn{{/atcType}}" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}"  data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
{{#isInCart}}In Cart{{/isInCart}}{{^isInCart}}{{#atcType}}View Product{{/atcType}}{{^atcType}}Add To Cart{{/atcType}}{{/isInCart}}
		</button>
    </a> 
       {{/products}}
	</div>`;

var facebookShareHref;
var emailShareHref;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function IsBuilder(productURL){
      var full_url = productURL + '.json';
  	  var builder = false;
      
      $.ajax({
        url: full_url,
        async: false,
        success: function(data) {
          // ... to do 
          // all your process with product data logic
          if (data.product.template_suffix == "options"){
            builder =  true;
          } else {

          }
        }
      });
      return builder;
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}



window.SwymCallbacks.push(fetchLists);

/* window.SwymCallbacks.push(swymRenderWishlist); Init Here */

function setupAcc(){
  //set up accordion modules
  var acc = document.getElementsByClassName("accordion");
  var i;
  console.log("entered");
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      console.log("clicked");
      this.classList.toggle("active");
      this.classList.toggle("change");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
}

function fetchLists(swat){
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  	wishlistContentsContainer.innerHTML = "";
	swat.fetchLists({
      callbackFn: function(lists) {
        for (let i=0; i<lists.length; i++){
          swat.generateSharedListURL(
            lists[i]["lid"],
            function(data){
              facebookShareHref = `https://www.facebook.com/sharer/sharer.php?u=`+ data;
              emailShareHref = `mailto:?subject=Cali Raised Wishlist&body=Check out my Wishlist from Cali Raised! ` + data;
            }, 
            function(data) {console.log(data); }
          );
          // Get wishlist items
          swat.fetchListDetails(lists[i]["lid"], function(products) {
           	  products = products["items"];
              var formattedWishlistedProducts = products.map(function(p) {
                  p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
                  p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
                  p.atcType = IsBuilder(p.du);
                  p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
                  return p;
              });
              
              var productCardsMarkup = '<div class="wishlistTitleArea accordion" id="' 
              + lists[i]["lid"] 
              +'"><div class="container"><div class="accordion-text"><h2>' 
              + lists[i]["lname"] 
              + '</h2></div><div class="accordion-indicator"><h2 class="indicatorText">+</h2></div></div></div><div class="panel">'
              + '<div class="panelTop"><a class="deleteButton" data-lid="'
              + lists[i]["lid"]
              + '">Delete List</a>'
              + '<h3>Share Your Wishlist:</h3><a href="' 
              + emailShareHref 
              + '" id="email-share" target="_blank"><i class="fas fa-envelope" style="font-size: 30px; padding-left: 10px;"></i></a><a href="' 
              + facebookShareHref 
              + '" id="facebook-share" target="_blank"><i class="fab fa-facebook-square" style="font-size: 30px; padding-left: 10px;"></i></a></div>'
              + SwymUtils.renderTemplateString(productCardMarkup, {
                  products: formattedWishlistedProducts
              })
              + '</div>';
            
              if(wishlistContentsContainer){
                  wishlistContentsContainer.innerHTML += productCardsMarkup;
                  attachClickListeners();
                  setupAcc();

              } else{
                console.log("Container not found, Wishlist Page element not found");
              }

          });
        }
      },
      errorFn: function(xhrObj) {
        // something went wrong
      }
    });
  
  

}

function generateShareURL(swat, id){
  swat.generateSharedListURL(
    id,
    function(data, sharedListId){
      var emailShare = document.getElementById("email-share");
      var facebookShare = document.getElementById("facebook-share");
      facebookShareHref = `https://www.facebook.com/sharer/sharer.php?u=`+ data;
      facebookShare.setAttribute("href", facebookShareHref);
      emailShareHref = `mailto:?subject=Cali Raised Wishlist&body=Check out my Wishlist from Cali Raised! ` + data;
      emailShare.setAttribute("href", emailShareHref);
    }, 
    function(data) {
    }
  );
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
    e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
	}, function(e) {
		console.log(e);
	});
}

function onViewMoreClick(e) {
  	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
    window.open(du, "_blank");
}


function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  	var viewMoreButtons = document.querySelectorAll("#swym-custom-view-more");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  	var deleteListBtns = document.querySelectorAll(".deleteButton");

  	//   Add to cart Btns
	for (var i = 0; i < viewMoreButtons.length; i++) {
		viewMoreButtons[i].addEventListener('click', onViewMoreClick, false);
	}
  
  	//   Add to cart Btns
	for (var i = 0; i < deleteListBtns.length; i++) {
		deleteListBtns[i].addEventListener('click', onRemoveListClick, false);
	}
  
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = e.currentTarget.getAttribute("data-variant-id");
  var empi = e.currentTarget.getAttribute("data-product-id");
  var durl = e.currentTarget.getAttribute("data-product-url");
  var lid = e.currentTarget.getAttribute("data-product-lid");


  var listItemMap = {
    epi: epi,  // unique epi per listid
    empi: empi,
    du: durl
  };
  

  if (epi) {
    window._swat.deleteFromList(lid, listItemMap, function(deletedListItem){
      // successfully deleted list item
		window.SwymCallbacks.push(fetchLists);
    }, function(xhrObj) {
      // something went wrong
    });
  }
}

function onRemoveListClick(e){
  e.preventDefault();
  var lid = e.currentTarget.getAttribute("data-lid");
  if(lid){
    window._swat.deleteList(lid, function(deletedListObj){
      // successfully deleted list
      console.log("Deleted list with listid", deletedListObj.lid);
      window.SwymCallbacks.push(fetchLists);
    }, function(xhrObject) {
      // something went wrong
    });
  }

	
}



